// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  background-color: var(--background);
  height: calc(100vh - env(safe-area-inset-top));
  /* Add padding for bottom navbar + extra space for credits */
  padding-bottom: calc(130px + env(safe-area-inset-bottom));
  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);
}

.update-container input,
.update-container select {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 0;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  background-color: var(--background-consistent);
}

.update-form {
  display: grid;
  gap: 4px;
  padding: 12px;
  font-size: 1.8rem;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.delete-container {
  display: grid;
  gap: 4px;
  padding: 12px;
  font-size: 1.5rem;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.update-container button {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: bold;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 0;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  background-color: var(--theme-consistent);
  color: white;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.update-container button:active {
  transform: scale(0.98);
  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
}

.update-items {
  text-align: center;
  padding: 12px;
  font-size: 1.5rem;
  color: var(--text-primary);
  padding-top: 4rem;
}

.update-error {
  font-weight: bold;
  color: #FF3A31;
  text-decoration: none;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 1rem;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.terms-dropdown-content {
  text-align: center;
  font-weight: bolder;
  font-size: 1.25rem;
}

.update-terms-link {
  text-decoration: none;
  color: var(--theme-consistent);
}

.btn-delete-account {
  font-size: 16px;
  color: white;
  font-weight: bold;
  background-color: #FF3A31;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  border-radius: 8px;
  text-align: center;
  height: 6vh;
  width: 100%;
  background-color: #FF3A31 !important;
  margin-bottom: 40px !important;
}

.update-success {
  margin-top: 32px;
  font-weight: bold;
  color: rgb(0, 187, 6);
}

.twofactorauth-success {
  color: #2ecc71; /* Green color for success */
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: #e1f5d1; /* Light green background color */
}

.update-container input:focus {
  outline: none;
  box-shadow: 0 0 2px 2px #4CAF50;
}

.update-container button:hover {
  background-color: var(--theme-consistent);
}

.update-container button:focus {
  outline: none;
  box-shadow: 0 0 2px 2px #4CAF50;
}

.qrcode-container {
  display: flex; /* Use flexbox to center the SVG */
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  margin: 0px auto;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  line-height: 200px;
}

.qrcode-container svg {
  max-width: 100%; /* Allow the SVG to fill the container */
  height: auto;
}

.credits-container {
  padding: 16px 8px;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 60px; /* Space between credits and navbar */
  position: relative;
  width: 100%;
}

.credits-container img {
  max-width: 200px;
  height: auto;
  margin-top: 8px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
  background-color: var(--theme-consistent);
  color: white;
  border-radius: 8px;
  margin-bottom: 12px;
  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30);
}

.section-header h3 {
  font-size: 1.8rem;
}

.section-content {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 12px;
  background-color: var(--background);
  border-radius: 8px;
  margin-bottom: 12px;
  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30);
}

.section-content h3 {
  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30);
}

.section-content button {
  font-size: 1.6rem !important;
  padding: 16px !important;
  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30) !important;
}

/* # css for personalInfo and security sections # */
.btn-update-section {
  font-size: 1.8rem;
}


@media (max-width: 768px) {
  .update-container {
    padding: 0 12px calc(90px + env(safe-area-inset-bottom)) 12px;
    padding-bottom: calc(150px + env(safe-area-inset-bottom));
  }

  .update-container input,
  .update-container select,
  .update-container button {
    font-size: 1.4rem;
    padding: 8px;
    margin: 8px 0;
    height: auto;
    min-height: 44px; /* Better touch target size */
  }

  .update-items {
    font-size: 1rem;
  }

  .credits-container {
    margin-bottom: 70px; /* Slightly more space on mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/update.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2FAA2F;EAC3F,mCAAmC;EACnC,8CAA8C;EAC9C,4DAA4D;EAC5D,yDAAyD;EACzD,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc,EAAE,4BAA4B;EAC5C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa,EAAE,kCAAkC;EACjD,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,wCAAwC;EACzD,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB,EAAE,qCAAqC;EAC1D,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;AACnB;;;AAGA;EACE;IACE,6DAA6D;IAC7D,yDAAyD;EAC3D;;EAEA;;;IAGE,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB,EAAE,6BAA6B;EACjD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB,EAAE,kCAAkC;EACzD;AACF","sourcesContent":[".update-container {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);\n  background-color: var(--background);\n  height: calc(100vh - env(safe-area-inset-top));\n  /* Add padding for bottom navbar + extra space for credits */\n  padding-bottom: calc(130px + env(safe-area-inset-bottom));\n  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);\n}\n\n.update-container input,\n.update-container select {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  background-color: var(--background-consistent);\n}\n\n.update-form {\n  display: grid;\n  gap: 4px;\n  padding: 12px;\n  font-size: 1.8rem;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.delete-container {\n  display: grid;\n  gap: 4px;\n  padding: 12px;\n  font-size: 1.5rem;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.update-container button {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-weight: bold;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 0;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  background-color: var(--theme-consistent);\n  color: white;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.update-container button:active {\n  transform: scale(0.98);\n  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);\n}\n\n.update-items {\n  text-align: center;\n  padding: 12px;\n  font-size: 1.5rem;\n  color: var(--text-primary);\n  padding-top: 4rem;\n}\n\n.update-error {\n  font-weight: bold;\n  color: #FF3A31;\n  text-decoration: none;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  font-size: 1rem;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.terms-dropdown-content {\n  text-align: center;\n  font-weight: bolder;\n  font-size: 1.25rem;\n}\n\n.update-terms-link {\n  text-decoration: none;\n  color: var(--theme-consistent);\n}\n\n.btn-delete-account {\n  font-size: 16px;\n  color: white;\n  font-weight: bold;\n  background-color: #FF3A31;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  border-radius: 8px;\n  text-align: center;\n  height: 6vh;\n  width: 100%;\n  background-color: #FF3A31 !important;\n  margin-bottom: 40px !important;\n}\n\n.update-success {\n  margin-top: 32px;\n  font-weight: bold;\n  color: rgb(0, 187, 6);\n}\n\n.twofactorauth-success {\n  color: #2ecc71; /* Green color for success */\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  background-color: #e1f5d1; /* Light green background color */\n}\n\n.update-container input:focus {\n  outline: none;\n  box-shadow: 0 0 2px 2px #4CAF50;\n}\n\n.update-container button:hover {\n  background-color: var(--theme-consistent);\n}\n\n.update-container button:focus {\n  outline: none;\n  box-shadow: 0 0 2px 2px #4CAF50;\n}\n\n.qrcode-container {\n  display: flex; /* Use flexbox to center the SVG */\n  justify-content: center;\n  align-items: center;\n  width: 300px;\n  height: 300px;\n  margin: 0px auto;\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  line-height: 200px;\n}\n\n.qrcode-container svg {\n  max-width: 100%; /* Allow the SVG to fill the container */\n  height: auto;\n}\n\n.credits-container {\n  padding: 16px 8px;\n  color: var(--text-primary);\n  text-align: center;\n  margin-bottom: 60px; /* Space between credits and navbar */\n  position: relative;\n  width: 100%;\n}\n\n.credits-container img {\n  max-width: 200px;\n  height: auto;\n  margin-top: 8px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 12px;\n  background-color: var(--theme-consistent);\n  color: white;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30);\n}\n\n.section-header h3 {\n  font-size: 1.8rem;\n}\n\n.section-content {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 12px;\n  background-color: var(--background);\n  border-radius: 8px;\n  margin-bottom: 12px;\n  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30);\n}\n\n.section-content h3 {\n  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30);\n}\n\n.section-content button {\n  font-size: 1.6rem !important;\n  padding: 16px !important;\n  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.30) !important;\n}\n\n/* # css for personalInfo and security sections # */\n.btn-update-section {\n  font-size: 1.8rem;\n}\n\n\n@media (max-width: 768px) {\n  .update-container {\n    padding: 0 12px calc(90px + env(safe-area-inset-bottom)) 12px;\n    padding-bottom: calc(150px + env(safe-area-inset-bottom));\n  }\n\n  .update-container input,\n  .update-container select,\n  .update-container button {\n    font-size: 1.4rem;\n    padding: 8px;\n    margin: 8px 0;\n    height: auto;\n    min-height: 44px; /* Better touch target size */\n  }\n\n  .update-items {\n    font-size: 1rem;\n  }\n\n  .credits-container {\n    margin-bottom: 70px; /* Slightly more space on mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
